import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData, convertToTimeDropDownValue } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { IdProps } from "../../interfaces/Global";
import { LmsPortalOptions, LmsTimeDropdownOptions } from "../../constants/GlobalConstants";

const LmsNewMenusEmailMasterTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="menu/email-master"
    deleteSuffix="menu/email-master"
  />;
};

const addEmailMasterFormFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Portal Option", LmsPortalOptions, { "name": "portalOption", required: true }),
    myForm.getInputField("Name", { required: true })
  ]);

  myForm.addCenteredGroup([myForm.getDropdownField("Email Template", "menu/email-template")]); 
  myForm.addCenteredGroup([myForm.getTextareaField("Trigger Event")]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", { inline: true, width: 3  })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description", { required: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Validation Comments")]);
  myForm.addCenteredGroup([    
    myForm.getCalendarField("Validated On", { required: true }),
    myForm.getDropdownField("Validated Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.validatedOn) })
  ]);
  myForm.addCenteredGroup([myForm.getInputField("Validated By")]);

  return myForm;
};

const AddEmailMasterForm = () => {
  const myForm = addEmailMasterFormFields(new BCFormController({}, { submitSuffix: "menu/email-master", submitMethod: "POST" }));
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={ myForm } actions={ formActions } />;
};

const EditEmailMasterForm = ({ id }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/email-master/${id}`);
  const myForm = addEmailMasterFormFields(new BCFormController(data, { 
    submitSuffix: "menu/email-master", 
    submitMethod: "PUT",
    deleteSuffix: "menu/email-master",
  }));
  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const LmsNewMenusEmailMaster = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <LmsNewMenusEmailMasterTable />}
    {isAdd && <AddEmailMasterForm />}
    {isEdit && <EditEmailMasterForm id={id} />}
  </>);
};

export default LmsNewMenusEmailMaster;